import { getAllNewsRequest, getNewsByIdRequest } from "../repositories/news_repository";
export const NewsService = () => {
  const fetchAllNews = async (setNewsList) => {
    try {
      const response = await getAllNewsRequest();
      if (response?.success) {
        setNewsList(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch news.");
    }
  };
  const fetchNewsById = async (id) => {
    try {
      const response = await getNewsByIdRequest(id);
      if (response?.success) {
        return response.data;
      } else {
        console.error("Failed to fetch news details:", response?.errors);
        throw new Error(response?.errors || "Failed to fetch news details");
      }
    } catch (error) {
      console.error("Error in fetchNewsById:", error);
      throw error;
    }
  };
  return {
    fetchAllNews,
    fetchNewsById,
  };
};
